import { DocumentRef } from "../../../models/documents/document-ref";
import { DOCUMENTS_STATUS_TYPES } from "../../../utils/constants/constants";

export const hasAllVerifiedDocuments = (documents: DocumentRef[]) => {
  let result = false;
  if (documents && documents.length) {
    result = documents.every(
      (doc) => doc?.status?.id?.toLowerCase() === DOCUMENTS_STATUS_TYPES.VERIFIED.id.toLowerCase()
    );
  }

  return result;
};

export const hasAllProcessedDocuments = (documents: DocumentRef[]) => {
  let result = false;
  if (documents && documents.length) {
    result = documents.every(
      (doc) => doc?.status?.id?.toLowerCase() === DOCUMENTS_STATUS_TYPES.PROCESSED.id.toLowerCase()
    );
  }

  return result;
};
